import { defineStore } from 'pinia'
import { Jrs } from '../apis/types/jrs'

export const useUserJrs = defineStore('userJrs', {
  state: () => ({
    jrsMap: {} as Record<string, Jrs[]>,
  }),

  actions: {
    setJrsByStoreId(storeId: string, jrsList: Jrs[]) {
      this.jrsMap[storeId] = jrsList
    },

    getJrs(storeId: string) {
      return this.jrsMap[storeId] || []
    },

    resetJrs() {
      this.jrsMap = {}
    },
  },
})
